import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormTemplate } from 'app/models/template';
import { WorkflowExecVariable } from 'app/models/workflow-exec-variable';
import { WorkflowForm } from 'app/models/workflow-form';
import { FormTemplateService } from 'app/services/form-template.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';
import { FieldsPickerComponent } from '../fields-picker/fields-picker.component';

@Component({
  selector: 'app-workflow-exec-variable',
  templateUrl: './workflow-exec-variable.component.html',
  styleUrls: ['./workflow-exec-variable.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkflowExecVariableComponent),
      multi: true
    }
  ]
})
export class WorkflowExecVariableComponent implements OnInit, ControlValueAccessor {

  @ViewChild('fieldsPicker', { static: false }) fieldsPicker: FieldsPickerComponent;
  @ViewChild('execVariableModal', { static: true}) execVariableModal: ModalDirective;

  constructor(private formTemplateService: FormTemplateService) {
  }

  @Input() disabled = false;
  @Input() workflowForms: WorkflowForm[];
  @Input() multi = true;
  @Input() title = 'Dynamic Variable';
  @Input() buttonTitle = 'Dynamic';
  @Input() buttonClass = 'btn-sm';
  @Input() fieldTypeFilter = [];

  @Output() willShowModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() closedModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOK: EventEmitter<WorkflowExecVariable> = new EventEmitter<WorkflowExecVariable>();

  isLoadingForm: boolean = false;
  cachedForm: FormTemplate;

  isSet: boolean = false;

  formRequiredError: boolean = false;
  fieldRequiredError: boolean = false;

  selectedWorkflowForm: WorkflowForm = null;
  selectedFields: string[] = [];

  ngOnInit(): void {
    this.cachedForm = null;
    this.formRequiredError = false;
    this.fieldRequiredError = false;
  }

  onChange = (workflowExecVariable: WorkflowExecVariable) => {};
  onTouched = () => {};

  onButtonClick() {
    this.willShowModal.emit(null);
    this.execVariableModal.show();
  }
  registerOnChange(fn: (workflowExecVariable: WorkflowExecVariable) => void) : void {
    this.onChange = (v: WorkflowExecVariable) => {this.isSet = (v != null); fn(v) };
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(v: WorkflowExecVariable) {
    if (v) {
      this.selectedWorkflowForm = this.workflowForms.find((f) => f.name == v.workflow_form_name);
      this.selectedFields = v.fields.map(f => f.field_name);
      this.isSet = true;
    } else {
      this.selectedWorkflowForm = null;
      this.selectedFields = [];
      this.isSet = false;
    }
  }

  clear() {
    this.selectedWorkflowForm = null;
    this.selectedFields = [];
    this.isSet = false;
  }
  onPickFields() {
    if (this.cachedForm && this.cachedForm.id == this.selectedWorkflowForm.form_template_id) {
      this.fieldsPicker.showPicker(this.cachedForm.schema, this.selectedFields);
    } else {
      this.isLoadingForm = true;
      this.formTemplateService.getById(this.selectedWorkflowForm.form_template_id).pipe(finalize(()=>{
        this.isLoadingForm = false;
        /** @todo handle errors */
      })).subscribe((f)=>{
        this.cachedForm = f;
        this.fieldsPicker.showPicker(this.cachedForm.schema, this.selectedFields);
      });
    }
  }

  execVariableModalOK() {
    this.formRequiredError = this.selectedWorkflowForm == null;
    this.fieldRequiredError = this.selectedFields.length == 0;

    if (this.formRequiredError || this.fieldRequiredError)
      return;

    this.onChange({
      workflow_form_name: this.selectedWorkflowForm.name,
      fields: this.selectedFields.map((f) => {return {field_name: f}; })
    });
    this.execVariableModal.hide();

    this.onOK.emit({
      workflow_form_name: this.selectedWorkflowForm.name,
      fields: this.selectedFields.map((f) => {return {field_name: f}; })
    });
  }
}
